import React from "react";
import {Helmet} from 'react-helmet';
import Faqs from "../Page/Faqs";
import Newsletter from "../Page/Newsletter";
import PopularHotels from "../Page/Hotels/Component/PopularHotels";
import PopularFlights from "../Page/PopularFlights";
import FlightsWidgit from "../Page/FlightsWidgit";
import Badge from "../Page/Badge";


function App1() {
  return (
   <>
    <Helmet>     
  <title>Thank You, Lowest Airfare and offers | cheapflightsprices.com</title>
  <meta name="description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time"/>
  <meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flight booking, cheap flight fares,flight booking offer,Cheap Flights Prices,cheapest ticket booking"/>
<meta property="og:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta property="og:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta property="og:site_name" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta name="Distribution" content="Global" />
<meta name="Robots" content="follow, index, all" />
<meta name="googlebot" content="index, follow" />
<meta http-equiv="Expires" content="never" />
<meta name="document-type" content="public" />
<meta name="revisit-after" content="daily" />
<meta name="country" content="India" />
<meta name="Language" content="English" />
<meta name='rating' content="general" />
<meta name="author" content="cheapflightsprices.com" />
<link rel="canonical" href="https://cheapflightsprices.com/contact-us.html" />
  </Helmet>
   <section id="banner_section" className="innerbannersection">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Thank You</h1>
      <h2>Thanks for reaching out! We'll get back to you soon.</h2>
      <FlightsWidgit/>
    </div>
  </section>
<Badge/>
 

    <main id="main">
    <PopularFlights/>
        <PopularHotels />
    <Faqs/>
    <Newsletter/>
      </main>
    </>
  );
}
export default App1;



